import { useEffect, useState } from "react";
import useMailSender from "./useMailSender.js";

export const useActionList = ({
  defaultActionList = ["Comment", "Download", "Share"],
  security,
}) => {
  const [actionList, setActionList] = useState([]);
  const { isMailSender } = useMailSender();

  useEffect(() => {
    const tempActionList = [...defaultActionList];

    if (isMailSender()) {
      setActionList(tempActionList);
      return;
    } else {
      tempActionList.includes("RemoveFile") &&
        tempActionList.splice(tempActionList.indexOf("RemoveFile"), 1);
      tempActionList.includes("RemoveFolder") &&
        tempActionList.splice(tempActionList.indexOf("RemoveFolder"), 1);
    }

    // verify security previewFiles and isSharingDisabled props and remove from actionList relevant actions and set new actionList state
    if (security?.previewFiles) {
      defaultActionList.includes("Download") &&
        tempActionList.splice(tempActionList.indexOf("Download"), 1);
    }
    if (security?.isSharingDisabled) {
      defaultActionList.includes("Share") &&
        tempActionList.splice(tempActionList.indexOf("Share"), 1);
    }
    setActionList(tempActionList);
  }, [security]);

  return actionList;
};
